import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MoveFolderSvg = function MoveFolderSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.565 13.15 7.52 8.765 6.44 9.852l2.457 2.663H1.5v1.5h7.286l-2.345 2.698 1.11 1.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.345 6.683H22v14.456H2v-3.373h1.478v1.974h16.946V8.082h-8.768L7.912 4.538H3.478v4.228H2V3.139h6.601z"
  }));
};
export var MoveFolder = function MoveFolder(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MoveFolderSvg
  }));
};